module.exports = __webpack_public_path__ + "img/eoin_logo.5b6d863e.png";